import {
  Datagrid,
  List,
  ReferenceInput,
  TextField,
  ExportButton,
  AutocompleteInput,
  useListContext,
  ReferenceField,
  NumberField,
} from 'react-admin'
import moment from 'moment'

import FilterComponent from '../../components/Filter'
import CustomMonthInput from '../../components/CustomMonthInput'
import { exportExcel } from '../../utils/exportExcel'
import { ROLES } from '../../components/constants'

const exporter = records => {
  const data = records.map(record => {
    return {
      'User ID': record.userId,
      'Publisher Id': record.publisherId,
      'Entity Type': record.entityType,
      'Entity Id': record.entityId,
      'Entity title': record.title,
      'Minutes Listened': record.totalMinutesListened,
      'Entity Duration': record.duration,
      Month: record.aggregationMonth,
    }
  })
  exportExcel({
    data,
    title: 'User Listening Time',
    type: 'xlsx',
  })
}

const Actions = ({ resource, currentSort, filterValues, exporter }) => {
  return (
    <ExportButton
      disabled={false}
      resource={resource}
      sort={currentSort}
      filter={filterValues}
      exporter={exporter}
      maxResults={1000000}
    />
  )
}

const CustomFilter = props => {
  const { filterValues } = useListContext()
  return (
    <FilterComponent {...props}>
      <CustomMonthInput label="Month" source="aggregationMonth" alwaysOn />
      <ReferenceInput label="Book" source="entityId" reference="books" alwaysOn>
        <AutocompleteInput
          optionText="title"
          filterToQuery={searchText => ({
            title: { $iLike: `%${searchText}%` },
          })}
        />
      </ReferenceInput>
      <ReferenceInput
        label={'Publisher'}
        source={'publisherId'}
        perPage={1000}
        reference="users"
        filter={{ role: ROLES.PUBLISHER }}
        alwaysOn>
        <AutocompleteInput
          optionText="name"
          options={{
            fullWidth: true,
          }}
          filterToQuery={searchText => ({
            name: { $iLike: `%${searchText}%` },
            role: ROLES.PUBLISHER,
          })}
        />
      </ReferenceInput>
      <ReferenceInput label="User" source="userId" reference="users" alwaysOn>
        <AutocompleteInput
          optionText="username"
          filterToQuery={searchText => ({
            username: { $iLike: `%${searchText}%` },
          })}
        />
      </ReferenceInput>
    </FilterComponent>
  )
}

const ListeningTimeList = props => {
  return (
    <List
      exporter={exporter}
      filters={<CustomFilter />}
      sort={{ field: 'id', order: 'DESC' }}
      actions={<Actions />}
      filterDefaultValues={{
        aggregationMonth: moment().format('YYYY-MM'),
        bookId: null,
      }}>
      <Datagrid bulkActionButtons={false} rowClick={false} {...props}>
        <ReferenceField reference="users" source="userId">
          <TextField source="username" label="User ID" />
        </ReferenceField>
        <ReferenceField
          reference="users"
          source="publisherId"
          label="Publisher">
          <TextField source="name" label="User ID" />
        </ReferenceField>
        <TextField label="Entity Type" source="entityType" />
        <TextField label="Entity Id" source="entityId" />
        <TextField label="Title" source="title" />
        <NumberField label="Minutes Listened" source="totalMinutesListened" />
        <TextField label="Entity Duration" source="duration" />
        <TextField label="Month" source="aggregationMonth" />
      </Datagrid>
    </List>
  )
}

export default ListeningTimeList
